import { __ } from "@wordpress/i18n";
import {
	useInnerBlocksProps,
	InspectorControls,
	useBlockProps,
	__experimentalUseColorProps as useColorProps,
	__experimentalGetSpacingClassesAndStyles as useSpacingProps,
} from "@wordpress/block-editor";
import {
	Panel,
	PanelBody,
	ToggleControl,
	RangeControl,
	SelectControl,
} from "@wordpress/components";

/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @return {Element} Element to render.
 */
export default function Edit(props) {
	const { attributes, setAttributes } = props;
	const colorProps = useColorProps(attributes);
	const spacingProps = useSpacingProps(attributes);

	const ALLOWED_BLOCKS = [
		"core/heading",
		"wpopus/icon-picker",
		"core/paragraph",
	];

	const customStyle = {
		"--wpopus-blob-size": `${attributes.blobSize}px`,
		"--wpopus-blob-pause-on-hover": `${
			attributes.blobStopOnHover ? "paused" : "running"
		}`,
	};

	const blobStyle = {
		...colorProps.style, // Default color styles
		...spacingProps.style, // Default spacing styles
		...customStyle,
	};

	const blocksProps = useBlockProps({ className: `wpopus-blob ${attributes.blobStyle}` });
	const { children, ...innerBlocksProps } = useInnerBlocksProps(blocksProps, {
		allowedBlocks: ALLOWED_BLOCKS,
	});

	function setOption(key, value) {
		setAttributes({ [key]: value });
	}

	return (
		<div {...innerBlocksProps} style={blobStyle}>
			<InspectorControls key="setting">
				<Panel>
					<PanelBody title={__("Flip Card Setting", "wpopus")}>
						<fieldset>
							<ToggleControl
								__nextHasNoMarginBottom={true}
								label={__("Pause on Hover", "wpopus")}
								checked={attributes.blobStopOnHover}
								onChange={(newValue) => {
									setOption("blobStopOnHover", newValue);
								}}
							/>
						</fieldset>

						<br />
						<fieldset>
							<RangeControl
								__nextHasNoMarginBottom={true}
								label={__("Size (px)", "wpopus")}
								value={attributes.blobSize}
								min={20}
								max={500}
								onChange={(newValue) => {
									setOption("blobSize", parseInt(newValue));
								}}
							/>
						</fieldset>

						<br />
						<fieldset>
							<SelectControl
								__nextHasNoMarginBottom={true}
								label={__("Blob Style", "wpopus")}
								labelPosition={"top"}
								value={attributes.blobStyle}
								options={[
									{ label: __("Style One", "wpopus"), value: "wpopus-blob-1" },
									{ label: __("Style Two", "wpopus"), value: "wpopus-blob-2" },
									{ label: __("Style Three", "wpopus"), value: "wpopus-blob-3" },
								]}
								onChange={(newValue) => {
									setOption("blobStyle", newValue);
								}}
							/>
						</fieldset>
					</PanelBody>
				</Panel>
			</InspectorControls>
		
			{children}
		</div>
	);
}
